/* eslint-disable no-unused-vars*/
/* eslint-disable no-useless-escape*/
/* eslint-disable react/prop-types*/
/* eslint-disable*/

import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { UserContext } from "../context/user/UserContext";
import { useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";
import useAuth from "../useAuth";
import useWebSocket, { ReadyState } from 'react-use-websocket';
import { Button, Divider, Menu, MenuItem } from '@mui/material';
import { alpha, styled } from "@mui/material/styles";
import ArchiveIcon from "@mui/icons-material/Archive";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import { getApiUrl, APPFACTOR, newSessionUID } from "./commons"
import { APPF_ICONS,SSS_ } from "./APPF_ICONS"
import { EventLogIcon } from "./eventlog/EventLog";
import { poolData} from "../UserPool";
import LOCAL_STORAGE_KEY from "../service/local-storage/constant";
import UI_VERSION from "../constant";
import ThemeToggler from "./theme-toggler";
import { ThemeContext } from "./theme-toggler/theme-context";
import { THEME_KEY, ICON_THEME_MAP } from "./theme-toggler/constant";
import ProjectInfoBar from './ProjectInfoBar'
import useProjectStore from '../store/projectStore';
import "./style/SidebarNav.css";

const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: "bottom",
            horizontal: "right"
        }}
        transformOrigin={{
            vertical: "top",
            horizontal: "right"
        }}
        {...props}
    />
))(({ theme }) => ({
    "& .MuiPaper-root": {
        borderRadius: 4,
        marginTop: theme.spacing(0.5),
        minWidth: 140,
        color: theme.palette.grey[300],
        boxShadow:
            "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 8px 10px -4px, rgba(0, 0, 0, 0.05) 0px 3px 5px -2px",          
        "& .MuiMenu-list": {
            padding: "2px 0"
        },
        "& .MuiMenuItem-root": {
            fontSize: 12,
            minHeight: 28,
            padding: "4px 8px",
            "& .MuiSvgIcon-root": {
                fontSize: 14,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1)
            },
            "&:active": {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity
                )
            }
        }
    }
}));

function SidebarNav() {
    const currentProjectId = useProjectStore(s => s.currentProjectId);
    const currentSEnv = useProjectStore(s => s.currentSEnv);
    const [appf_tenant_info] = useState(localStorage.appf_tenant_info?JSON.parse(localStorage.appf_tenant_info):{});
    const deployEnabled = typeof appf_tenant_info.sku!=="undefined"?( appf_tenant_info?.sku == "full-internal" || appf_tenant_info?.sku?.toLowerCase().indexOf("deploy") > -1 ) :false
    const [uiVersion, setUIVersion] = useState(localStorage.getItem(LOCAL_STORAGE_KEY.UI_VERSION))
    const [currentWSURL,setCurrentWSURL] = useState(`${localStorage.wsURL || APPFACTOR.__DEFAULT_WS_URL}:${localStorage.wsPort || APPFACTOR.__DEFAULT_PORT}/ws/v2`)
    const { gdata,setGdata } = useContext(UserContext);
    const [anchorElScan, setAnchorElScan] = useState(null);
    const [notificationsEnabled] = useState(false)
    
    const [vSock, setVSock] = useState({
        v1: {
            available: false,
        },
        v2: {
            available: false,
        }
    });

    const { logout } = useAuth();
    const navigate = useNavigate();
    // Sidebar is always in full mode now; removed menuLow/minimized logic
    const [shouldIConnect, setShouldIConnect] = useState(false);
    const [init, setInit] = useState(0);
    const [checkOldVersion, setCheckOldVersion] = useState(0);

    const [sessionUID, setSessionUID] = useState(newSessionUID());
    const [height, setHeight] = useState(0);
    const [showWindow, setShowWindow] = useState(false);
    const [logoRef, setLogoRef] = useState();
    const logoReff = useRef();
    const mnuHoverRef = useRef(null);

    // Theme context for explicit Light/Dark switching
    const { theme, setTheme } = useContext(ThemeContext);
    const isDarkMode = theme === THEME_KEY.DARK;

    // Anchor for theme menu opened from .mnuHover
    const [anchorElTheme, setAnchorElTheme] = useState(null);
    const openThemeMenu = Boolean(anchorElTheme);
    const handleOpenThemeMenu = (event) => setAnchorElTheme(event.currentTarget);
    const handleCloseThemeMenu = () => setAnchorElTheme(null);

    useEffect(() => {
        window._g.vSock = vSock;
    }, [vSock]);

    useEffect(() => {
        if (!uiVersion) {
            setUIVersion(localStorage.getItem(LOCAL_STORAGE_KEY.UI_VERSION) || UI_VERSION.OLD);
        }

        if (checkOldVersion > 0) {
            let wsock_v1 = {};
            let wsURL = `${localStorage.wsURL || APPFACTOR.__DEFAULT_WS_URL}:${localStorage.wsPort || APPFACTOR.__DEFAULT_PORT}`;

            try {
                wsock_v1 = new WebSocket(wsURL);
                wsock_v1.onopen = function () {
                    if (wsock_v1.readyState == 1) {
                        setVSock(
                            {
                                v1: {
                                    available: true,
                                    url: wsURL
                                }
                                ,
                                v2: {
                                    available: false
                                }
                            }
                        );

                        wsock_v1.close();
                        wsock_v1 = null;

                        if(wsURL !== currentWSURL) {
                            setCurrentWSURL(wsURL);
                        }

                        setGdata(p => {
                            return {
                                ...p,
                               version:1
                            }
                        });

                        setShouldIConnect(true);
                    }
                }

                wsock_v1.onmessage = function () {}

                wsock_v1.onerror = function () {}
            }

            catch (e) {
                console.log(e);
            }
        }
    }, [checkOldVersion, currentWSURL, setGdata]);

    useEffect(() => {
        if (init > 0 && !(window._g.vSock?.v1?.available || window._g.vSock?.v2?.available)) {
            let wsock_v2 = {};
            let wsURL = `${localStorage.wsURL || APPFACTOR.__DEFAULT_WS_URL}:${localStorage.wsPort || APPFACTOR.__DEFAULT_PORT}/ws/v2`;

            try {
                wsock_v2 = new WebSocket(wsURL);
                wsock_v2.onopen = function () {
                    if (wsock_v2.readyState == 1) {
                        setVSock(
                            {
                                v1: {
                                    available: false,
                                },
                                v2: {
                                    available: true,
                                    url: wsURL
                                }
                            }
                        );

                        wsock_v2.close();
                        wsock_v2 = null;

                        // Only update if different to prevent infinite loop
                        if (wsURL !== currentWSURL) {
                            setCurrentWSURL(wsURL);
                        }

                        setGdata(p => {
                            return {
                                ...p,
                               version: 2
                            }
                        });

                        setShouldIConnect(true);
                    }
                }

                wsock_v2.onmessage = function () {}

                wsock_v2.onerror = function () {
                    setCheckOldVersion(p => (p + 1));
                }
            }

            catch (e) {
                console.log(e);
            }
        }
    }, [init, setGdata]); // Removed currentWSURL from dependencies to prevent loop


    useEffect(() => {
        const updateWindowDimensions = () => {
            const newHeight = window.innerHeight;

            setHeight(newHeight);
        };

        window.addEventListener("resize", updateWindowDimensions);

        return () => window.removeEventListener("resize", updateWindowDimensions)
    }, []);

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const { sendMessage, lastMessage, readyState } = useWebSocket(currentWSURL,
        {
            onError: () => {},
            shouldReconnect: () => true,
            reconnectAttempts: 20,
            reconnectInterval: 1000,
        },
        shouldIConnect
    );

    const connectionStatus = {
        [ReadyState.CONNECTING]: 'Connecting',
        [ReadyState.OPEN]: 'Open',
        [ReadyState.CLOSING]: 'Closing',
        [ReadyState.CLOSED]: 'Closed',
        [ReadyState.UNINSTANTIATED]: 'Uninstantiated',
    }[readyState];



    useEffect(() => {
        setGdata(p => {
            return {
                ...p,
                connectionStatus,
                connected: connectionStatus == "Open"
            }
        });

        if (connectionStatus != "Open") {
            sendMessage(`
                {
                "type":"get_protocols",
                "id":"${sessionUID}"
                }
            `);
        }

        if (connectionStatus != "Open" && connectionStatus != "Connecting") {
            setVSock(() => {
                return {
                    v1: {
                        available: false
                    },
                    v2: {
                        available: false
                    }
                }
            });
        }

        window._g.connectionStatus = connectionStatus;
        try{
            let me = document.querySelector('a[data-val="./scan"]')
            if (connectionStatus == "Open") {
                
                if( !me.classList.contains("connected")){
                    me.classList.add("connected");
                }
            }else{
                if( me.classList.contains("connected")){
                    me.classList.remove("connected");
                }
            }
        }catch(e){/**/ }
    }, [readyState, connectionStatus, setGdata]);

    function setAdditionalData(inData){
        let token = poolData.refreshToken();
        let url=getApiUrl(poolData.envURL)
        token = poolData.accessToken;

        try{
            if( window._g.hashicorp_vault_token ){
                inData["hashicorp_vault_token"] =`${ window._g.hashicorp_vault_token }`;
            }
        }catch(e){/**/ }
        // if(inData.type == "scan"){
           inData["log_level"] ="debug";
        // }
        inData["api_access_token"] =`${token}`;
        inData["api_url_prefix"] =`${url}`;
        inData["project_id"] =`${currentProjectId}`;
        inData["env_id"] =`${currentSEnv}`;
        inData["secret_store_password"] =`${window._g.localSecret}`;
        inData["store_password"] =`${window._g.localSecret}`;
    }

    useEffect(() => {
        function processIncommingMessage(event) {
            try {
                if (!isMobile) {
                    let eventData = {...(typeof event.data !== 'undefined') ? JSON.parse(event.data) : {}, 
                        eTimeStamp: event.timeStamp,
                        timestamp: new Date().getTime()
                    };
                    if (eventData.type == APPFACTOR.command) {
                        if (eventData.connect == true) {
                            if (!(window._g.vSock.v2.available || window._g.vSock.v1.available)) {
                                setInit(p => p + 1);
                            }

                            setTimeout(() => {
                                if (window._g.vSock.v2.available) {
                                    sendMessage(`
                                         {
                                            "type":"get_protocols",
                                            "id":"${sessionUID}"
                                         }
                                    `);
                                } else if (window._g.vSock.v1.available) {
                                    sendMessage(`
                                        {
                                            "ProtocolsRequest":{
                                               "id":"${sessionUID}",
                                               "timestamp":0
                                            }
                                         }
                                    `);
                                }
                            }, 100);
                        }
                        
                        if (window._g.connectionStatus == 'Open') {
                            if (eventData.scanRaw == true) {
                                if(window._g.vSock.v2.available){                                    
                                    setAdditionalData(eventData.payload)
                                    sendMessage(JSON.stringify(eventData.payload));
                                }
                            } else if (eventData.extract == true) {
                                let payload = ``;
                             
                                let token = poolData.refreshToken();
                                token = poolData.accessToken;

                                if (window._g.vSock.v2.available) {
                                    let payloadJ = {
                                        type     : "extract",
                                        id       : `${eventData.sessionUID  || sessionUID}`,
                                    }

                                    const assessSourceTypeName = "source_code_extract";
                                    if( eventData.apps ){
                                        payloadJ.apps = eventData.apps;
                                        payloadJ.type = "multi_extract";
                                    }else if(eventData[assessSourceTypeName]){
                                        payloadJ.type = assessSourceTypeName;

                                        payloadJ = {
                                            ...payloadJ,
                                            ...eventData[assessSourceTypeName]
                                        }
                                    }else{
                                        payloadJ = {
                                            ...payloadJ,
                                            protocol : `${eventData.protocol}`,
                                            app_id   : `${eventData.app_id}`,
                                            folder   : `${eventData.folder}`,
                                            host     : `${eventData.host}`    
                                        }
                                    }

                                    setAdditionalData(payloadJ)
                                    payload = JSON.stringify(payloadJ)
                                } else {
                                    payload = `{
                                        "${APPFACTOR.__AEX}": {
                                            "id"       :"${eventData.sessionUID  || sessionUID}",
                                            "timestamp":0,
                                            "protocol" : "${eventData.protocol}",
                                            "app_id"   :"${eventData.app_id}",
                                            "folder"   :"${eventData.folder}",
                                            "host"     :"${eventData.host}"
                                        }
                                    }`;
                                }

                                sendMessage(payload);
                            } else if (eventData.scan == true) {
                                let payload = "";

                                let token = poolData.refreshToken();
                                token = poolData.accessToken;

                                if (typeof eventData.targets !== 'undefined') {
                                    payload = JSON.stringify({
                                        type: "scan",
                                        id: eventData.sessionUID  || sessionUID,
                                        targets: eventData.targets
                                    });

                                    let payloadJ = JSON.parse(payload);
                                    setAdditionalData(payloadJ)
                                    payload = JSON.stringify(payloadJ)
                                    
                                } else if (typeof eventData.start_ip !== 'undefined') {
                                    payload = `{
                                        "type": "scan",
                                        "id":"${eventData.sessionUID  || sessionUID}",
                                        "targets":[
                                            {
                                                "type":"ip_range",
                                                "start_ip":"${eventData.start_ip}",
                                                "end_ip":"${eventData.end_ip}",
                                                "protocol_ids":${eventData.protocol}
                                            }
                                        ]
                                    }`;

                                    let payloadJ = JSON.parse(payload);
                                    setAdditionalData(payloadJ)
                                    payload = JSON.stringify(payloadJ)
                                }else if (typeof eventData.subnet === 'undefined') {
                                    if (window._g.vSock.v2.available) {
                                        payload = `{
                                            "type": "scan",
                                            "id":"${eventData.sessionUID  || sessionUID}",
                                            "targets":[
                                                {
                                                    "type":"host_list",
                                                    "hosts":${eventData.host},
                                                    "protocol_ids":${eventData.protocol}
                                                }
                                            ]
                                        }`;

                                        let payloadJ = JSON.parse(payload);
                                        setAdditionalData(payloadJ)
                                        payload = JSON.stringify(payloadJ)
                                    } else if (window._g.vSock.v1.available) {
                                        payload = `{
                                            "${APPFACTOR.__ASCAN}":{
                                                "id":"${eventData.sessionUID  || sessionUID}",
                                                "timestamp":0,
                                                "hosts":[
                                                    {
                                                        "type":"host_list",
                                                        "hosts":${eventData.host},
                                                        "protocol_ids":[
                                                            "${eventData.protocol}"
                                                        ]
                                                    }
                                                ]
                                            }
                                        }`;
                                    }
                                } else {
                                    if (window._g.vSock.v2.available) {
                                        payload = `{
                                            "type":"scan",
                                            "id":"${eventData.sessionUID  || sessionUID}",
                                            "targets":[
                                                {
                                                    "type":"cidr",
                                                    "subnet":"${eventData.subnet}",
                                                    "protocol_ids":${eventData.protocol}
                                                }
                                            ]
                                        }`;
                                    
                                        let payloadJ = JSON.parse(payload);
                                        setAdditionalData(payloadJ)
                                        
                                        payload = JSON.stringify(payloadJ)
                                    } else if (window._g.vSock.v1.available) {
                                        payload = `{
                                            "${APPFACTOR.__ASCAN}":{
                                                "id":"${sessionUID}",
                                                "timestamp":0,
                                                "hosts":[
                                                    {
                                                        "type":"cidr",
                                                        "subnet":"${eventData.subnet}",
                                                        "protocol_ids":[
                                                            "${eventData.protocol}"
                                                        ]
                                                    }
                                                ]
                                            }
                                        }`;
                                    }
                                }
        
                                sendMessage(payload);
                            }
                        }
                    }
                    else if(eventData.type  == "progress"){
                            if( eventData.app_id ){
                                if(typeof window._g.eventLog === "undefined"){
                                    window._g.eventLog = []
                                }

                                window._g.eventLog.push(eventData)
                            }
                    }
                }
            } catch (e) {/* */ }
        }

        window.addEventListener("message", processIncommingMessage, false);

        // Previously used to restore minimized state from localStorage and adjust watermark margin.
        // menuLow logic removed; sidebar remains full width.
    }, []);

    const handleLogout = () => {
        logout();
        
        navigate("/", { replace: true });
    };

    const activateD = useCallback((elem) => {
        try {
            document.querySelectorAll(".wrapper1 .left-side a").forEach(e => e.classList.remove('active'));
            let el = elem.target;

            while (el.tagName !== "A") {
                el = el.parentNode;
            }

            el.classList.add("active");
            let route = "#";

            route = el.getAttribute("data-val");

            if (route !== "#") {
                navigate(route);
            }
        } catch (e) {
            console.log(e);
        }
    }, [navigate]);

    useEffect(() => {
        async function getData(inData) {
            if (gdata.version == 1) {
                let a = await inData.text();

                return a;    
            } else {
                return inData;
            }
        }

        if (lastMessage) {
            getData(lastMessage.data).then(msgData => {
                try {
                    if (msgData[0] != '"') {
                        window.postMessage(msgData);
                       
                        let msg = JSON.parse(msgData);
                        if (typeof msg[APPFACTOR.__AEXP] !== 'undefined') {
                            window._g.modTM_RUNS[msg[APPFACTOR.__AEXP].app_id].progress = msg[APPFACTOR.__AEXP].progress.message;
                        }

                        if (`${msg.type}` == 'protocols') {
                            window._g.protocols = msg.protocols;
                        }

                        if (typeof msg[APPFACTOR.__PRES] !== 'undefined') {
                            window._g.protocols = msg[APPFACTOR.__PRES].protocols;
                        }
                    }
                } catch (e) {/**/ }
            });
        }
    }, [lastMessage, gdata, setGdata]);

    // Removed dynamic presentation width syncing with minimized state

    const checkIfMobile = () => [/iPhone/i, /iPad/i, /Android/i, /webOS/i, /BlackBerry/i, /Windows Phone/i].some((item) => navigator.userAgent.match(item));

    let mEnabled = !checkIfMobile();

      const mBottom = 80
    return (
        <>
        <div style={{
            
    position: "absolute",
    bottom: "calc(0.24vw)",
    left: "6px",
    width: "50%",
    height: "12px",
    fontSize: "0.42vw",
    fontWeight: "bold",
    textAlign: "left",
    zIndex: 1000,
    maxWidth: "50%",
    color:isDarkMode ? '#FFF' : '#000'
    }}>{window.APPFACTOR_VERSION}</div>
            <div
                ref={mnuHoverRef}
                className="mnuHover"
                onClick={(e) => {
                    // Only open theme menu when SHIFT key is pressed
                    if (e && e.shiftKey) {
                        handleOpenThemeMenu(e);
                    }
                }}
                // title="Theme (hold Shift and click)"
                style={{ marginLeft: -17, width: 72, height: 40 }}
            >

            </div>
            <div
                className={"wrapper1"}
                style={{
                    background: "transparent",
                    color: isDarkMode ? "rgba(255,255,255,0.84)" : "rgba(0,0,0,0.8)",
                    minHeight: 580,
                    position: "relative",
                    width: "102px",
                }}
            >
                <div className="wrp"></div>
                
                {/* Theme switcher menu anchored to .mnuHover */}
                <StyledMenu
                    anchorEl={anchorElTheme}
                    open={openThemeMenu}
                    onClose={handleCloseThemeMenu}
                    MenuListProps={{ "aria-labelledby": "theme-switcher" }}
                    PaperProps={{ sx: { minWidth: 120 } }}
                >
                    {isDarkMode ? (
                        <MenuItem
                            sx={{
                                fontFamily: 'Inter',
                                fontWeight: 500,
                                fontStyle: 'normal',
                                fontSize: '14px',
                                lineHeight: '20px',
                                letterSpacing: 0,
                                bgcolor: '#f0f0f0',
                                color: '#FFF',
                                borderRadius: '6px',
                                border: '1px solid rgba(0,0,0,0.08)',
                            }}
                            onClick={() => {
                                // Close menu first to avoid flicker, then switch theme
                                handleCloseThemeMenu();
                                setTimeout(() => setTheme(), 0);
                            }}
                        >
                            <span className="theme-toggler__icon" style={{ display: 'inline-flex', alignItems: 'center', marginRight: 8 }}>
                                {ICON_THEME_MAP[THEME_KEY.DARK]}
                            </span>
                            Light mode
                        </MenuItem>
                    ) : (
                        <MenuItem
                            sx={{
                                fontFamily: 'Inter',
                                fontWeight: 500,
                                fontStyle: 'normal',
                                fontSize: '14px',
                                lineHeight: '20px',
                                letterSpacing: 0,
                                bgcolor: '#f0f0f0',
                                color: '#FFF',
                                borderRadius: '6px',
                                border: '1px solid rgba(0,0,0,0.08)',
                            }}
                            onClick={() => {
                                // Close menu first to avoid flicker, then switch theme
                                handleCloseThemeMenu();
                                setTimeout(() => setTheme(), 0);
                            }}
                        >
                            <span className="theme-toggler__icon" style={{ display: 'inline-flex', alignItems: 'center', marginRight: 8 }}>
                                {ICON_THEME_MAP[THEME_KEY.LIGHT]}
                            </span>
                            Dark mode
                        </MenuItem>
                    )}
                </StyledMenu>

                <div
                    className="left-side"
                    style={{
                        width: "102px",
                        backgroundColor: isDarkMode ? '#000' : 'rgb(251,251,251)',
                        color: isDarkMode ? '#FFF' : '#000'
                    }}
                >
                    <div className="side-wrapper">
                        <div className="side-title"  style={{
                            marginBottom: mBottom,
                            display: 'flex',
                            justifyContent: 'center'
                        }}>
                            <div
                                ref={logoReff}
                                id="menu-toggle"
                                className={"appf-logo2"}
                                onMouseOver={() => {}}
                                onMouseOut={() => {}}
                                style={{
                                    position: 'relative',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                    marginTop: 0,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}
                                onClick={() => {}}
                            >

                               {SSS_}
                                {/* <div style={{
                                    maxWidth: menuLow ? "calc(33%)" : "114px",
                                    position: "absolute",
                                    overflow: "hidden",
                                    marginTop: !menuLow ? 68 : 48,
                                    paddingLeft: !menuLow ? 0 : 0,
                                    marginLeft: menuLow ? 0 : 6,
                                    width: 180,
                                    textTransform: "uppercase",
                                    textAlign: "left",
                                    color: "grey",
                                }}>
                                    {!isMobile && window.innerWidth > 900 ?
                                        <>
                                            <div
                                                style={{
                                                    fontSize: 12
                                                }}
                                            >
                                                {localStorage.getItem("tenantData")? JSON.parse(localStorage.getItem("tenantData")).tenant:""}
                                            </div>

                                            <div
                                                style={{
                                                    fontSize: 8
                                                }}
                                            >
                                                {localStorage.getItem("tenantData")?JSON.parse(localStorage.getItem("tenantData")).username:""}
                                            </div>
                                        </>
                                        :
                                        <></>
                                    }
                                </div> */}
                            </div>

                            <StyledMenu
                                MenuListProps={{
                                    "aria-labelledby": "demo-customized-button"
                                }}
                                anchorEl={logoRef}
                                open={showWindow}
                                onClose={() => {
                                    setShowWindow(false);
                                    setLogoRef(null);
                                }}
                            >
                                <MenuItem
                                    onClick={() => {
                                        setShowWindow(false);
                                        setLogoRef(null);
                                    }}
                                    disableRipple
                                />
                                <Divider sx={{ my: 0.5 }} />
                            </StyledMenu>
                        </div>
                        <ProjectInfoBar/>
                        <div
                            className={"side-menu"}
                            style={{ paddingTop: 0 }}
                        >
                            <a data-val="./dashboard" onClick={activateD}>
                                <div
                                    className="icon"
                                    style={{ marginLeft: -2, marginTop: 4 }}
                                >
                                    {APPF_ICONS.APPF_dashboardIcon}
                                </div>
                                <div className="menu-label">{"Dashboard"}</div>
                            </a>

                            <a data-val="./discovery" onClick={activateD}
                            onDoubleClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                if(e.shiftKey && e.altKey){
                                    navigate("./traceability");
                                } 

                            }}
                            >
                                <div
                                    className="icon"
                                    style={{ marginLeft: -1.5, marginTop: 5 }}
                                >
                                    {APPF_ICONS.APPF_discoveryIcon}
                                </div>
                                <div className="menu-label">{"Discovery"}</div>
                            </a>

                            <a data-val="./apps" onClick={activateD}>
                                <div
                                    className="icon"
                                    style={{marginLeft: -1.5, marginTop: 5 }}
                                >
                                    {APPF_ICONS.APPF_appsIcon}
                                </div>
                                <div className="menu-label">{"App"}</div>
                            </a>

                            {deployEnabled  &&
                            <a data-val="./designer" onClick={activateD} >
                                <div
                                    className="icon"
                                    style={{ marginLeft: -1.5, marginTop: 14 }}
                                >
                                  {APPF_ICONS.APPF_designerIcon}
                                </div>
                                <div className="menu-label">{"Designer"}</div>
                            </a>
                            }

                            {deployEnabled &&
                            <a data-val="./deploy" onClick={activateD} >
                                <div
                                    className="icon deploy"
                                    style={{ marginLeft: -1.5, marginTop: 5 }}
                                >

                                    {APPF_ICONS.APPF_deployIcon}
                                </div>
                                <div className="menu-label">{"Deploy"}</div>
                            </a>
                            }
                                <a data-val="./eventlog" onClick={activateD} >
                                    <div
                                        className="icon"
                                        style={{ marginLeft: -1.5, marginTop: 5 }}
                                    >
                                        <EventLogIcon />
                                    </div>
                                    <div className="menu-label">{"Events log"}</div>
                                </a>
    

                            {localStorage.getItem(LOCAL_STORAGE_KEY.FORGE_ENABLED) === "true" && (
                            <a data-val="./forge" onClick={activateD}>
                                <div className="icon" style={{ marginLeft: -1.5, marginTop: 4 }}>
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 2L2 7l10 5 10-5-10-5z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M2 17l10 5 10-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M2 12l10 5 10-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </div>
                                <div className="menu-label">{"Forge"}</div>
                            </a>
                            )}

                            <a data-val="./introspection" onClick={activateD}>
                                <div
                                    className="icon"
                                    style={{
                                        marginLeft: -1.5,
                                        marginTop: 4
                                    }}
                                >
                                    {APPF_ICONS.APPF_multiverseIcon}
                                </div>
                                <div className="menu-label">{"Multiverse"}</div>
                            </a>

                            <a data-val="./security" onClick={activateD}>
                                <div
                                    className="icon"
                                    style={{
                                        marginLeft: -1.5,
                                        marginTop: 4
                                    }}
                                >
                                    <APPF_ICONS.APPF_securityBlast width={28}/>
                                </div>
                                <div style={{marginTop:-7}} className="menu-label"><div>Security</div><div>Blast</div></div>
                            </a>

                            <a
                                data-val="./monitor"
                                className="monitor"
                                style={{ display: "none" }}
                                onClick={activateD}
                            >
                                <div
                                    className="icon"
                                    style={{
                                        marginLeft: -1.5,
                                        marginTop: 6
                                    }}
                                >
                                    <svg width="34" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g transform="translate(2,0)">
                                            <path d="M13.4979 26.5639C20.7141 26.5639 26.564 20.714 26.564 13.4978C26.564 6.28163 20.7141 0.431763 13.4979 0.431763C6.28175 0.431763 0.431885 6.28163 0.431885 13.4978C0.431885 20.714 6.28175 26.5639 13.4979 26.5639Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M6.70581 9.80598C7.5694 4.38698 10.2854 0.431763 13.4979 0.431763C15.2251 0.431763 16.7882 1.55874 18.0145 3.45431" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M20.385 10.4321C20.5143 11.4489 20.5792 12.4728 20.5793 13.4978C20.5793 20.7174 17.41 26.5682 13.4979 26.5682C10.2811 26.5682 7.5694 22.6086 6.70581 17.1896" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M16.8616 19.3227C19.1995 19.7128 21.3892 20.7255 23.2003 22.2546" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M3.7998 22.2546C5.61157 20.7239 7.80306 19.711 10.1428 19.3227" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M22.4534 5.34987C22.7168 5.15556 22.9629 4.95262 23.1961 4.74536" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M3.7998 4.74969C5.95877 6.71435 9.5081 7.99246 13.4979 7.99246C14.4231 7.99304 15.347 7.9223 16.2613 7.78088" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M9.74561 13.4978H26.5683" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M0.431885 13.4978H3.21695" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M13.498 15.4495V0.431763" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M13.498 26.5682V22.5352" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M19.6078 9.15397C20.8574 9.15397 21.8704 8.14097 21.8704 6.89138C21.8704 5.64178 20.8574 4.62878 19.6078 4.62878C18.3582 4.62878 17.3452 5.64178 17.3452 6.89138C17.3452 8.14097 18.3582 9.15397 19.6078 9.15397Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M6.4208 15.7604C7.67039 15.7604 8.68339 14.7474 8.68339 13.4978C8.68339 12.2482 7.67039 11.2352 6.4208 11.2352C5.1712 11.2352 4.1582 12.2482 4.1582 13.4978C4.1582 14.7474 5.1712 15.7604 6.4208 15.7604Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M15.7605 18.9988C15.7605 19.4463 15.6278 19.8838 15.3792 20.2558C15.1306 20.6279 14.7772 20.9179 14.3638 21.0892C13.9504 21.2604 13.4954 21.3052 13.0565 21.2179C12.6176 21.1306 12.2145 20.9151 11.8981 20.5987C11.5816 20.2823 11.3661 19.8791 11.2788 19.4402C11.1915 19.0013 11.2363 18.5464 11.4076 18.1329C11.5788 17.7195 11.8688 17.3661 12.2409 17.1175C12.613 16.8689 13.0504 16.7362 13.4979 16.7362C13.7952 16.7356 14.0897 16.7938 14.3645 16.9073C14.6392 17.0208 14.8889 17.1874 15.0991 17.3976C15.3093 17.6079 15.476 17.8575 15.5895 18.1323C15.703 18.407 15.7611 18.7015 15.7605 18.9988V18.9988Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </g>

                                        <defs></defs>
                                    </svg>
                                </div>
                                <div className="menu-label">{"Monitor"}</div>
                            </a>

                            {mEnabled ?
                                <>
                                    <a
                                        data-val="./scan"
                                        // className={connectionStatus == "Open" ? " connected active" : ""}
                                        onContextMenu={() => {}}
                                        onClick={(ev) => {
                                            if (!isMobile) {
                                                if (ev.shiftKey == true) {
                                                    ev.stopPropagation()
                                                    {
                                                        setAnchorElScan(document.querySelector('a[data-val="./scan"]'));
                                                    }
                                                } else {
                                                    if (!(vSock.v2.available || vSock.v1.available)) {
                                                        setInit(p => p + 1);
                                                    }

                                                    if (window._g.vSock.v2.available) {
                                                        sendMessage(`{
                                                            "type":"get_protocols",
                                                            "id":"${sessionUID}"
                                                            }`
                                                        );
                                                    } else if (window._g.vSock.v1.available) {
                                                        sendMessage(`{
                                                            "ProtocolsRequest":{
                                                                "id":"${sessionUID}",
                                                                "timestamp":0
                                                            }
                                                        }`);
                                                    }
                                                }
                                            }

                                            activateD(ev);
                                        }}
                                    >
                                        <div
                                            className="icon"
                                            style={{
                                                filter: connectionStatus == "Open" ? "" : "grayscale(100%)",
                                                position: "relative"
                                            }}
                                        >
                                            <div className="oversion">
                                                {(connectionStatus == "Open" ? (currentWSURL.endsWith("ws/v2")?"v2":"v1") : "")}
                                            </div>

                                            {APPF_ICONS.APPF_radarIcon}
                                        </div>
                                        
                                        <div className="menu-label">{"Scan"}</div>
                                    </a>

                                    

                                    <Menu
                                        className="scanMenu"
                                        id="scanMenu"
                                        anchorEl={anchorElScan}
                                        open={anchorElScan != null}
                                        onClose={() => setAnchorElScan(null)}
                                    >
                                        <div
                                            className="mstep active"
                                            style={{
                                                margin: 20,
                                                marginTop: 0,
                                                marginBottom: 0,
                                                height: 150,
                                                maxWidth: 402,
                                                minWidth: 402
                                            }}
                                        >
                                            <div
                                                className="asset421"
                                                style={{
                                                    margin: 0,
                                                    fontFamily: "InterL",
                                                    fontSize: 20,
                                                    marginBottom: 30
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        marginLeft: -9,
                                                        marginTop: -9,
                                                        borderRadius: "99em",
                                                        paddingLeft: 7,
                                                        paddingTop: 7,
                                                        paddingBottom: 0,
                                                        paddingRight: 4,
                                                        border: "0.42px solid rgba(255,255,255,0.242)",
                                                        filter: "drop-shadow(1px 1px 11px rgba(255,255,255,0.42)) grayscale(100%) brightness(1.75)",
                                                        opacity: 0.842
                                                    }}
                                                >
                                                    {APPF_ICONS.APPF_radarIcon}
                                                </div>

                                                <span
                                                    style={{
                                                        paddingLeft: 106,
                                                        fontSize: 16,
                                                        textShadow: "2px 0 4px #000000",
                                                        color: "rgba(255,255,255,0.942)"
                                                    }}
                                                >
                                                    Change Scan Settings
                                                </span>
                                            </div>

                                            <div
                                                style={{
                                                    zIndex: 22,
                                                    fontSize: 14,
                                                    margin: 10,
                                                    marginTop: 15
                                                }}
                                            >
                                                <span
                                                    style={{ marginRight: 28 }}
                                                >
                                                    WS - URL
                                                </span>

                                                <span>
                                                    <input
                                                        id="idwsurl"
                                                        data={localStorage.wsURL || APPFACTOR.__DEFAULT_WS_URL}
                                                        defaultValue={localStorage.wsURL || APPFACTOR.__DEFAULT_WS_URL}
                                                    />
                                                </span>
                                            </div>

                                            <div
                                                style={{
                                                    zIndex: 22,
                                                    fontSize: 14,
                                                    margin: 10,
                                                    marginTop: 28
                                                }}
                                            >
                                                <span
                                                    style={{ marginRight: 28 }}
                                                >
                                                    WS - port
                                                </span>

                                                <span>
                                                    <input
                                                        id="idwsport"
                                                        defaultValue={localStorage.wsPort || APPFACTOR.__DEFAULT_PORT}
                                                    />
                                                </span>
                                            </div>

                                            <div
                                                style={{
                                                    marginTop: 0
                                                }}
                                                className="wButton save"
                                                onClick={() => {
                                                    let wsport = "";
                                                    let oldwsport = "";
                                                    let wsurl = "";
                                                    let oldwsurl = "";

                                                    try {
                                                        let wsportEL = document.getElementById("idwsport");
                                                        wsport = wsportEL.value;
                                                        oldwsport = wsportEL.getAttribute("data");

                                                        if (wsport !== "" && parseInt(wsport) && parseInt(wsport) > 0 && parseInt(wsport) < 65535) {
                                                            localStorage.wsPort = wsport;
                                                        }
                                                    } catch (e) { /**/ }

                                                    try {
                                                        let wsurlEL = document.getElementById("idwsurl");
                                                        wsurl = wsurlEL.value;
                                                        oldwsurl = wsurlEL.getAttribute("data");

                                                        let validWS = new RegExp('^(wss?:\\\/\\\/)([0-9]{1,3}(?:\\.[0-9]{1,3}){3}|[^\\\/]+)$', 'gm');

                                                        if (validWS.test(wsurl)) {
                                                            localStorage.wsURL = wsurl;
                                                        }
                                                    } catch (e) {/**/ }

                                                    setAnchorElScan(null);
                                                }}
                                            >
                                                Save
                                            </div>

                                            <div
                                                style={{
                                                    marginTop: 0
                                                }}
                                                className="wButton cancel"
                                                onClick={() => {
                                                    setAnchorElScan(null);
                                                }}
                                            >
                                                Cancel
                                            </div>
                                        </div>
                                    </Menu>
                                </>
                                :
                                <></>
                            }

                            <a>
                                <Button
                                    className="repMenu"
                                    style={{
                                        width: 90,
                                        height: 42,
                                        marginLeft: -6,
                                        zIndex: 0,
                                        backgroundColor: "transparent",
                                        textTransform: "unset",
                                    }}
                                    id="demo-customized-button"
                                    aria-controls={open ? "demo-customized-menu" : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={open ? "true" : undefined}
                                    variant="contained"
                                    disableElevation
                                    onClick={handleClick}
                                    startIcon={
                                        <div
                                            className="icon"
                                            style={{ marginLeft: 6, marginTop: 1 }}
                                        >
                                            <svg
                                                width="22"
                                                height="22"
                                                style={{ marginLeft: 8, marginTop: 2 }}
                                                viewBox="0 0 36 16"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <g transform="translate(2 0) scale(2)">
                                                    <path d="M2.9 9.78748H1V12.875H2.9V9.78748Z" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="square" />
                                                    <path d="M10.5 9.55005H8.59998V12.875H10.5V9.55005Z" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="square" />
                                                    <path d="M6.70005 5.75H4.80005V12.875H6.70005V5.75Z" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="square" />
                                                    <path d="M14.3 5.75H12.4V12.875H14.3V5.75Z" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="square" />
                                                    <path d="M1.95 6.70005C2.47467 6.70005 2.9 6.27472 2.9 5.75005C2.9 5.22538 2.47467 4.80005 1.95 4.80005C1.42533 4.80005 1 5.22538 1 5.75005C1 6.27472 1.42533 6.70005 1.95 6.70005Z" stroke="currentColor" strokeMiterlimit="10" />
                                                    <path d="M9.54998 6.70005C10.0746 6.70005 10.5 6.27472 10.5 5.75005C10.5 5.22538 10.0746 4.80005 9.54998 4.80005C9.02531 4.80005 8.59998 5.22538 8.59998 5.75005C8.59998 6.27472 9.02531 6.70005 9.54998 6.70005Z" stroke="currentColor" strokeMiterlimit="10" />
                                                    <path d="M5.75005 2.9C6.27472 2.9 6.70005 2.47467 6.70005 1.95C6.70005 1.42533 6.27472 1 5.75005 1C5.22538 1 4.80005 1.42533 4.80005 1.95C4.80005 2.47467 5.22538 2.9 5.75005 2.9Z" stroke="currentColor" strokeMiterlimit="10" />
                                                    <path d="M13.35 2.9C13.8747 2.9 14.3 2.47467 14.3 1.95C14.3 1.42533 13.8747 1 13.35 1C12.8254 1 12.4 1.42533 12.4 1.95C12.4 2.47467 12.8254 2.9 13.35 2.9Z" stroke="currentColor" strokeMiterlimit="10" />
                                                    <path d="M2.6217 5.0784L5.0784 2.6217" stroke="currentColor" strokeMiterlimit="10" />
                                                    <path d="M8.87833 5.0784L6.42163 2.6217" stroke="currentColor" strokeMiterlimit="10" />
                                                    <path d="M10.2217 5.0784L12.6784 2.6217" stroke="currentColor" strokeMiterlimit="10" />
                                                </g>
                                            </svg>
                                        </div>
                                    }
                                >
                                    {"Reports"}
                                </Button>

                                <StyledMenu
                                    id="demo-customized-menu"
                                    MenuListProps={{
                                        "aria-labelledby": "demo-customized-button"
                                    }}
                                    anchorEl={anchorEl}
                                    open={open}
                                    onClose={handleClose}
                                >
                                    <MenuItem
                                        onClick={() => {
                                            try {
                                                let token = poolData.refreshToken();
                                                token = poolData.accessToken;
                                                let repAPI = getApiUrl(poolData.envURL);

                                                const osEOLReport = `os-eol-report`;
                                                fetch(`${repAPI}/reports/${osEOLReport}`, {
                                                    headers: {
                                                        authorization: token ? `Bearer ${token}` : '',
                                                        "X-Project-Id": `${currentProjectId}`,
                                                        "X-Environment-Id":`${currentSEnv}`
                                                    }
                                                })
                                                    .then((response) => response.blob())
                                                    .then((data) => {
                                                        const element = document.createElement("a");
                                                        element.href = URL.createObjectURL(data);
                                                        element.download = `${osEOLReport}.csv`;
                                                        document.body.appendChild(element); // Required for this to work in FireFox
                                                        element.click();
                                                    });
                                            } catch (e) {/* */}

                                            setAnchorEl(null);
                                        }}
                                        disableRipple
                                    >
                                        <FileCopyIcon /> OS EOL report
                                    </MenuItem>

                                    <Divider sx={{ my: 0.5 }} />

                                    <MenuItem
                                        onClick={() => {
                                            try {
                                                let token = poolData.refreshToken()
                                                token = poolData.accessToken;
                                                let repAPI = getApiUrl(poolData.envURL);
                                                const installedSoftwareEOLReport = `installed-packages-eol-report`;

                                                fetch(`${repAPI}/reports/${installedSoftwareEOLReport}`, {
                                                    headers: {
                                                        authorization: token ? `Bearer ${token}` : '',
                                                        "X-Project-Id": `${currentProjectId}`,
                                                        "X-Environment-Id":`${currentSEnv}`
                                                    }
                                                })
                                                    .then((response) => response.blob())
                                                    .then((data) => {
                                                        const element = document.createElement("a");
                                                        element.href = URL.createObjectURL(data);
                                                        element.download = `${installedSoftwareEOLReport}.csv`;
                                                        document.body.appendChild(element); // Required for this to work in FireFox
                                                        element.click();
                                                    });
                                            } catch (e) {/* */}

                                            setAnchorEl(null);
                                        }}
                                        disableRipple
                                    >
                                        <ArchiveIcon /> Software EOL report
                                    </MenuItem>
                                </StyledMenu>
                            </a>

                            <a
                                className="logout"
                                onClick={handleLogout}
                                title="Logout"
                            >
                                <div
                                    className="icon"
                                    style={{ marginLeft: -1, marginTop: 4 }}
                                >
                                    <svg
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="far"
                                        data-icon="hdd"
                                        className="svg-inline--fa fa-hdd fa-w-18"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 576 512"
                                    >
                                        <path
                                            fill="currentColor"
                                            d="M567.403 235.642L462.323 84.589A48 48 0 0 0 422.919 64H153.081a48 48 0 0 0-39.404 20.589L8.597 235.642A48.001 48.001 0 0 0 0 263.054V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V263.054c0-9.801-3-19.366-8.597-27.412zM153.081 112h269.838l77.913 112H75.168l77.913-112zM528 400H48V272h480v128zm-32-64c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32zm-96 0c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32z"
                                        >
                                        </path>
                                    </svg>
                                </div>

                                <div className="menu-label">{"Logout"}</div>
                            </a>
                        </div>
                    </div>

                    {(<ThemeToggler enabled={localStorage.getItem('themeToggleEnabled') === 'true'}/>)}
                </div>
            </div>
        </>
    );
}

export default SidebarNav;